/** CCC Retenção workspace — same funnel as Recuperação with Entrada as first sub-section. */

export type RetencaoSectionKey = 'por_contactar' | 'em_tratamento' | 'pre_fecho' | 'fecho';

export type RetencaoSubsection = {
  substage: string;
  label: string;
};

export type RetencaoSection = {
  key: RetencaoSectionKey;
  title: string;
  accent: string;
  subsections: RetencaoSubsection[];
};

export const RETENCAO_SUBSTAGE_ENTRADA = 'retencao-entrada';

export const RETENCAO_SECTIONS: RetencaoSection[] = [
  {
    key: 'por_contactar',
    title: 'Por contactar',
    accent: '#dc2626',
    subsections: [
      { substage: RETENCAO_SUBSTAGE_ENTRADA, label: 'Entrada' },
      { substage: 'retencao-por-contactar-iniciado-atribuido', label: 'Iniciado/Atribuído' },
      { substage: 'retencao-por-contactar-nao-atendido', label: 'Não Atendido' },
      { substage: 'retencao-por-contactar-incontactavel', label: 'Incontactável' },
    ],
  },
  {
    key: 'em_tratamento',
    title: 'Em Tratamento',
    accent: '#8b5cf6',
    subsections: [
      { substage: 'retencao-em-tratamento-aguardar-fatura', label: 'A aguardar Fatura' },
      { substage: 'retencao-em-tratamento-aguardar-proposta-bo', label: 'A aguardar Proposta BO' },
      { substage: 'retencao-em-tratamento-sem-interesse', label: 'Sem Interesse' },
      { substage: 'retencao-em-tratamento-pendente', label: 'Pendente' },
      { substage: 'retencao-em-tratamento-fidelizados', label: 'Fidelizados' },
    ],
  },
  {
    key: 'pre_fecho',
    title: 'Pré-Fecho',
    accent: '#2563eb',
    subsections: [
      { substage: 'retencao-pre-fecho-proposta-enviada', label: 'Proposta Enviada' },
      { substage: 'retencao-pre-fecho-assinado', label: 'Assinatura' },
    ],
  },
  {
    key: 'fecho',
    title: 'Fecho',
    accent: '#10b981',
    subsections: [
      { substage: 'retencao-fecho-pendente-documentos', label: 'Pendente Documentos' },
      { substage: 'retencao-fecho-contrato-submetido', label: 'Contrato Submetido' },
    ],
  },
];

export const RETENCAO_ALL_SUBSTAGES = RETENCAO_SECTIONS.flatMap((s) =>
  s.subsections.map((sub) => sub.substage)
);

export const retencaoSubstageLabel = (substage: string): string => {
  for (const sec of RETENCAO_SECTIONS) {
    const sub = sec.subsections.find((s) => s.substage === substage);
    if (sub) return sub.label;
  }
  return substage;
};

export const retencaoSectionForSubstage = (substage: string): RetencaoSection | undefined =>
  RETENCAO_SECTIONS.find((sec) => sec.subsections.some((s) => s.substage === substage));

export const normalizeRetencaoSubstage = (substage: string): string => substage;

/**
 * Marcação-based Retenção workspace (CccRetencaoWorkspace) — same substages as Recuperação.
 * Client-upload Retenção board uses RETENCAO_* above; marcação panels/tables use these re-exports.
 */
export {
  WORKSPACE_SECTIONS,
  ALL_WORKSPACE_SUBSTAGES,
  SUBSTAGE_AGENDAMENTOS,
  SUBSTAGE_AGUARDAR_PROPOSTA_BO,
  SUBSTAGE_CONTRATO_SUBMETIDO,
  normalizeWorkspaceSubstage,
  subsectionLabel,
  sectionForSubstage,
} from './recuperacaoWorkspace';

export type { WorkspaceSectionKey, WorkspaceSection, WorkspaceSubsection } from './recuperacaoWorkspace';
